const React = require('react');
const formatNum = require('mn-utils/formatNum');

const {apiAdminStatistic} = require("../../../../../../api/admin/statistic");
const WrapperWithLoading = require('../../../../../dumb/WrapperWithLoading/B');
const withState = require('../../../../../../utils/withState');
const formatNumCoin = require('../../../../../../utils/formatNumCoin');
const formatNumFiat = require('../../../../../../utils/formatNumFiat');

const DataBlock = require("./DataBlock");
const {AdminPageHeader} = require("../../../../../dumb/AdminHelpers/AdminLayout");
const noop = require("mn-utils/noop");
const {AdminDatepicker} = require("../../../../../dumb/FormInputs");
const {BtnTableGlobalRefresh} = require("../../../../../dumb/AdminHelpers/Buttons");
const BtnTableGlobal = require("../../../../../dumb/AdminHelpers/Buttons/components/BtnTableGlobal");
const UpdateIcon = require("@material-ui/icons/Update").default;



module.exports = withState((setState, self, onMount) => {
  const currencyCode = 'EUR';

  const defaultState = [{}];

  self.state = {
    loading: true,
    currentDate: new Date(),
    invoices: defaultState,
    volumesFeeOverall: defaultState,
    monthlyVolumes: defaultState,
    overallVolumes: defaultState,
    volumeAvailable: defaultState,
  };

  const fetchData = ({date, force_cache}) => {
    const dateObj = new Date(date);

    return apiAdminStatistic({
      month: dateObj.getMonth() + 1,
      year: dateObj.getFullYear(),
      force_cache
    }).then((res) => {
      const {
        pending_withdrawals = {},
        volumes_fee_overall = {},
        volumes_monthly = {},
        volumes_overall = {},
        volume_available = {},
      } = res.finance || {};

      const getAmount = (obj) => {
        const dataHandler = ({amount = 0, currency_code = ''}) => ({amount, currencyCode: currency_code});
        const eur = dataHandler(obj['EUR'] || {currency_code: 'EUR'});
        const arr = Object.keys(obj).filter((key) => key !== 'EUR').map((key) => dataHandler(obj[key]));
        return eur.amount > 0 ? [eur, ...arr] : arr;
      };

      setState({
        invoices: getAmount(pending_withdrawals),
        volumesFeeOverall: getAmount(volumes_fee_overall),
        monthlyVolumes: getAmount(volumes_monthly),
        overallVolumes: getAmount(volumes_overall),
        volumeAvailable: getAmount(volume_available),
        loading: false,
      });
    });
  }

  const changePeriod = (_, currentDate) => {
    setState({loading: true, currentDate});
    fetchData({date: currentDate})
  }
  const forceCache = () => {
    setState({loading: true});
    fetchData({date: self.state.currentDate, force_cache: true});
  }

  onMount(() => {
    fetchData({date: self.state.currentDate});
  });

  const formAmountString = ({amount, currencyCode}) => {
    const formatFN = currencyCode === 'EUR' ? formatNumFiat : formatNumCoin;
    return `${self.state.loading ? '120 000' : formatFN(amount)} ${currencyCode}`
  };

  return (state) => {
    const {
      invoices,
      volumesFeeOverall,
      monthlyVolumes,
      overallVolumes,
      volumeAvailable
    } = state;

    const overallData = [
      {
        name: 'Overall merchants unwithdrawn balance',
        value: volumeAvailable.map(formAmountString).join(' | '),
      },
      {
        name: 'Aggregated Monthly transacted volume',
        value: monthlyVolumes.map(formAmountString).join(' | '),
      },
      {
        name: 'Overall pending payout',
        value: invoices.map(formAmountString).join(' | '),
      },
      {
        name: 'Overall Transacted volume',
        value: overallVolumes.map(formAmountString).join(' | '),
      },
      {
        name: 'Overall commisions earned',
        value: volumesFeeOverall.map(formAmountString).join(' | '),
      },
    ];

    return (
      <>
        <AdminPageHeader
          title="Dashboard"
          additionalData={(
            <div className="layoutRow">
              <div>
                <BtnTableGlobal
                  icon={UpdateIcon}
                  text="Cache"
                  onClick={forceCache}
                />
              </div>
              <AdminDatepicker
                className="w140 p0-i ml15"
                format="MM.yyyy"
                disableFuture
                minDate={new Date(2022, 0, 1)}
                value={state.currentDate}
                views={['month', 'year']}
                onChange={changePeriod}
              />
            </div>
          )}
        />
        <WrapperWithLoading
          className="mt30"
          loading={state.loading}
        >
          <DataBlock items={overallData.slice(0, 2)} />
          <DataBlock items={overallData.slice(2, 5)} />
        </WrapperWithLoading>
      </>
    )
  }
})
